import React from "react";
import { Field, reduxForm } from "redux-form";
import { useDispatch } from "react-redux";
import { closeModal } from "reducers/Modal";
import { duplicateQrDesign, getQrDesigns } from "reducers/QrDesigns";
import { ReduxControls, Confirm } from "rhombus-react";
import { QR_DESIGN_DUPLICATE } from "widgets/forms/list";
import { maxLength, required } from "forms/validators/validators";


import "./DuplicateQrCodeDesignModal.css";

const MAX_LENGTH_DESIGN_NAME = 1024;
const designNameMaxLength = maxLength(MAX_LENGTH_DESIGN_NAME);


function DuplicateQrCodeDesignModal({
	handleSubmit,
	submitting,
	invalid,
	designId,
	libraryId,
}) {
	const dispatch = useDispatch();

	function handleClose() {
		dispatch(closeModal());
	}

	function onSubmit({ name }) {
		return dispatch(duplicateQrDesign(designId, name)).then((resp) => {
			if (resp?.success) {
				dispatch(getQrDesigns(libraryId));
				handleClose();
			}
		});
	}

	return (
		<Confirm.ConfirmModal
			title="Duplicate QR Code Design"
			desc={
				<div className="duplicate-qr-modal-desc">
					<Field
						name="name"
						required
						showCharCount
						charMax={MAX_LENGTH_DESIGN_NAME}
						component={ReduxControls.Input}
						label="Design Name"
						validate={[required, designNameMaxLength]}
						autoFocus
					/>
				</div>
			}
			commitLabel="Duplicate QR Code Design"
			isCommitDisabled={invalid || submitting}
			commitTheme="blue"
			onCommit={handleSubmit(onSubmit)}
			onClose={handleClose}
			className="duplicate-qr-modal"
		/>
	);
}

export default reduxForm({
	form: QR_DESIGN_DUPLICATE,
	enableReinitialize: true,
})(DuplicateQrCodeDesignModal);
